import React from 'react';
import PropTypes from 'prop-types';
import { placeholderCellFor } from './placeholderCell';

/**
 * Single placeholder row. Each cell is content-shaped gibberish chosen by the
 * column's type (see placeholderCell.js). Without `columns`, `columnCount`
 * generic text cells are rendered (the ghost, no-columns case).
 */
var PreviewTablePlaceholderRow = function(props) {
  var columns = props.columns;
  var rowIndex = props.rowIndex;
  var cellCount = columns ? columns.length : props.columnCount;

  var cells = [];
  for (var i = 0; i < cellCount; i++) {
    var cell = placeholderCellFor(columns ? columns[i] : undefined, rowIndex);
    var content;
    if (cell.kind === 'boolean') {
      content = (
        <div
          aria-hidden="true"
          className={
            'field-data-boolean' + (cell.value ? ' field-data-boolean-true' : '')
          }
        />
      );
    } else if (cell.kind === 'image') {
      content = <div className="preview-table-greek-image" aria-hidden="true" />;
    } else {
      content = (
        <span
          className="preview-table-greek"
          aria-hidden="true"
          style={{ textAlign: cell.align }}>
          {cell.text}
        </span>
      );
    }
    cells.push(
      <div key={i} className="preview-table-cell">
        {content}
      </div>
    );
  }

  return (
    <div className="preview-table-row">
      {cells}
      {/* Filler cell to extend background across remaining width */}
      <div className="preview-table-cell-filler" />
    </div>
  );
};

PreviewTablePlaceholderRow.propTypes = {
  columnCount: PropTypes.number,
  columns: PropTypes.array,
  rowIndex: PropTypes.number.isRequired,
};

PreviewTablePlaceholderRow.defaultProps = {
  columnCount: 4,
};

export default PreviewTablePlaceholderRow;
